import './mega_menu.scss';
import { create_div } from 'js/utils';

let last_open = null;
let fullwidth_con = null;

const initial_con = document.querySelector('.mega_menu_init_con');

function init(){
    if( !initial_con ) return;
    
    const inner_con = initial_con.children[0];
    if( !inner_con ) return;

    const sub_menus = [];
    for(let i = 0; i < inner_con.children.length; i++ ) {
        sub_menus.push(inner_con.children[i]);
    }
    sub_menus.forEach(sub_menu_init)
}
init();

function sub_menu_init(el){

    if( !el.dataset.trigger ) return;

    const trigger = document.querySelector(el.dataset.trigger);
    if( !trigger ) {
        console.warn(`mega menu trigger el not found ${el.dataset.trigger}`)
        return;
    }

    trigger.classList.add('with_mega_menu');
    
    disable_link(trigger.children[0]);

    let destination;
    if( el.classList.contains('fullwidth') ) {
        // fullwidth
        fullwidth_init();
        destination = fullwidth_con;
    }
    else {
        // align on parent link
        destination = trigger;
    }

    const sub_menu_con = create_div('mega_menu_sub', destination);
    sub_menu_con.style.display = 'none';
    sub_menu_con.classList.add(get_elementor_class(el.parentElement));
    sub_menu_con.append(el);

    display_init(trigger, sub_menu_con, destination);
}

function get_elementor_class(el){
    for( const class_name of el.className.split(' ')){
        if( class_name.includes('elementor-') ) {
            return class_name;
        }
    }
    return '';
}

function fullwidth_init(){
    if( fullwidth_con ) return;
    const fullwidth_container = create_div('mega_menu_fullwidth');
    document.querySelector('.elementor-location-header').append(fullwidth_container);
    fullwidth_con = create_div('inner', fullwidth_container);
}

function display_init(el, target, target_con) {
    
    let timeout;
    
    const show = ()=>{
        el.classList.add('mm_hover')
        target.style.display = '';
    }

    const hide = ()=>{
        el.classList.remove('mm_hover')
        target.style.display = 'none';
    }

    const hover_in_handler = ()=>{
        
        clearTimeout(timeout);
        
        if( last_open && last_open !== target ) {
            last_open.style.display = 'none';
        }
        last_open = target;

        show();
    }

    const hover_out_handler = ()=>{
        clearTimeout(timeout);
		timeout = setTimeout(hide, 300);
    }
    
	el.addEventListener('pointerenter', hover_in_handler);
	el.addEventListener('pointerleave', hover_out_handler);
    target_con.addEventListener('pointerenter', hover_in_handler);
	target_con.addEventListener('pointerleave', hover_out_handler);
}

function disable_link(a){
    a.addEventListener('click', (e)=>e.preventDefault());
}